import { render, staticRenderFns } from "./GroupPerson.vue?vue&type=template&id=14c1d5a3&scoped=true"
import script from "./GroupPerson.vue?vue&type=script&lang=js"
export * from "./GroupPerson.vue?vue&type=script&lang=js"
import style0 from "./GroupPerson.vue?vue&type=style&index=0&id=14c1d5a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c1d5a3",
  null
  
)

export default component.exports